import { call, takeLatest } from "redux-saga/effects";
import { getToken } from "../../../../utils/common";
import axiosT1 from "../../../../utils/axios";
import API from "../../../../common/api_config";
import ACTIONS from "src/common/action_constant";


export function* getDedicatedProductMaster(action) {
  try {
    const resp = yield call(
      axiosT1.get,
      API.getDedicatedProductMasterUrl,
      {
        headers: {
          token: getToken(),
        },
        params: action.params
      }
    );

    if (action.onSuccess) {
      action.onSuccess(resp.data && resp.data.data || []);
    }
  } catch (e) {
    console.log('e:', e);
    if(action.onError) {
        action.onError(e);
    }
  }
}

export function* addDedicatedProductMaster(action) {
    try {
      const resp = yield call(
        axiosT1.post,
        API.addDedicatedProductMasterUrl,
        action.payload,
        {
          headers: {
            token: getToken()
          }
        }
      );
      if (action.onSuccess) {
        action.onSuccess(resp);
      }
    } catch (e) {
        if(action.onError) {
            action.onError(e);
        }
      console.log('e:', e)
    }
}

export function* updateDedicatedProductMaster(action) {
    try {
        const resp = yield call(
          axiosT1.put,
          API.updateDedicatedProductMasterUrl,
          action.payload,
          {
            headers: {
              token: getToken()
            }
          }
        );
        if (action.onSuccess) {
          action.onSuccess(resp);
        }
      } catch (e) {
          if(action.onError) {
              action.onError(e);
          }
        console.log('e:', e)
      }
}

export function* deleteDedicatedProductMaster(action) {
    try {
        const resp = yield call(
          axiosT1.post,
          API.deleteDedicatedProductMasterUrl,
          action.payload,
          {
            headers: {
              token: getToken()
            }
          }
        );
        if (action.onSuccess) {
          action.onSuccess(resp);
        }
      } catch (e) {
          if(action.onError) {
              action.onError(e);
          }
        console.log('e:', e)
      }
}



export function dedicatedProductSaga() {
  return [
     takeLatest(ACTIONS.PLANTS.GET_DEDICATED_PRODUCT_MASTER, getDedicatedProductMaster),
     takeLatest(ACTIONS.PLANTS.ADD_DEDICATED_PRODUCT_MASTER, addDedicatedProductMaster),
     takeLatest(ACTIONS.PLANTS.UPDATE_DEDICATED_PRODUCT_MASTER, updateDedicatedProductMaster),
     takeLatest(ACTIONS.PLANTS.DELETE_DEDICATED_PRODUCT_MASTER, deleteDedicatedProductMaster)
  ]
}